import type { IIndicatorNorms } from '../../Pages/SinglePatientDetails/Service/overview/types';

export interface INormV2 {
  key: string;
  norm: IIndicatorNorms;
}

export const paramKeyMapping: Record<string, string> = {
  cadence: 'STEP_RATE',
  stance_asymmetry: 'SYMMETRY_DIF',
  stride_length: 'STEP_LENGTH',
  tug_duration_seconds: 'duration',
};
